{
"api": {
"baseUrl": "https://uat-xreg-api.segestest.dk"
}
}
